import { render, staticRenderFns } from "./ResidentContactsTab.vue?vue&type=template&id=08a7c302&scoped=true&"
import script from "./ResidentContactsTab.vue?vue&type=script&lang=ts&"
export * from "./ResidentContactsTab.vue?vue&type=script&lang=ts&"
import style0 from "./ResidentContactsTab.vue?vue&type=style&index=0&id=08a7c302&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a7c302",
  null
  
)

export default component.exports